import { render, staticRenderFns } from "./ExamChoices.vue?vue&type=template&id=fe37385e"
import script from "./ExamChoices.vue?vue&type=script&lang=js"
export * from "./ExamChoices.vue?vue&type=script&lang=js"
import style0 from "./ExamChoices.vue?vue&type=style&index=0&id=fe37385e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports